import { createFileRoute } from '@tanstack/react-router'

import { CustomerProductPage } from '#/modules/customers/customer-product-page'

export const Route = createFileRoute('/_shell/customers/')({
  component: CustomerProductPage,
})
